<form>
    <ui-form-field [label]="fieldLabel">
        <input advizeoInput [formControl]="valueControl" [type]="fieldType" [required]="true" />
        @if (infoLabel) {
            <ui-form-hint>
                {{ infoLabel }}
            </ui-form-hint>
        }
        @for (error of valueControl.errors | keyvalue; track error) {
            <ui-form-error>
                @if (error.key === 'required') {
                    {{ 'ERRORS.FORM.REQUIRED' | translate }}
                } @else {
                    {{ error.value }}
                }
            </ui-form-error>
        }
    </ui-form-field>
</form>
